const removeExtraProtocol = (input = "") => {
  const matches = input.match(/(https?:\/\/)/g);
  if (matches && matches.length > 1) {
    const firstProtocol = matches[0];
    const withoutProtocols = input.replace(/(https?:\/\/)/g, "");
    return firstProtocol + withoutProtocols;
  }
  return input;
};

export default removeExtraProtocol;
